import { Stack, StackPage, StackSwitch, StackSwitchApiContext, usePersistedStateId } from "@comet/admin";
import { AddCircleOutline } from "@mui/icons-material";
import { Button } from "@mui/material";
import { PageHeader } from "@src/components";
import { useContext } from "react";
import { FormattedMessage, useIntl } from "react-intl";

import { AddCamera } from "./add/Camera";
import CamerasSummary from "./CamerasSummary";
import { EditCamera } from "./edit/Camera";
import Table from "./Table";

export const AddButton = () => {
    const stackApi = useContext(StackSwitchApiContext);

    return (
        <Button
            variant="contained"
            color="primary"
            startIcon={<AddCircleOutline style={{ fontSize: "20px" }} />}
            onClick={() => stackApi.activatePage("add", "camera")}
        >
            <FormattedMessage id="reviermanager.page.devices.add" defaultMessage="Gerät hinzufügen" />
        </Button>
    );
};

export default () => {
    const intl = useIntl();
    const persistedStateId = usePersistedStateId();

    return (
        <Stack topLevelTitle={intl.formatMessage({ id: "reviermanager.page.devices", defaultMessage: "Geräte" })}>
            <StackSwitch initialPage="table">
                <StackPage name="table">
                    <PageHeader title={<FormattedMessage id="reviermanager.page.devices" defaultMessage="Geräte" />} button={<AddButton />} />
                    <CamerasSummary />
                    <Table persistedStateId={persistedStateId} />
                </StackPage>
                <StackPage name="add" title={intl.formatMessage({ id: "reviermanager.page.devices.add", defaultMessage: "Gerät hinzufügen" })}>
                    <AddCamera />
                </StackPage>
                <StackPage name="edit" title={intl.formatMessage({ id: "reviermanager.page.devices.edit", defaultMessage: "Gerät bearbeiten" })}>
                    {(id) => <EditCamera id={id} />}
                </StackPage>
            </StackSwitch>
        </Stack>
    );
};
